import React from "react";
import { SERVICES } from "../mock";

const Services = () => {
  return (
    <section id="services" className="dhs-services">
      <div className="dhs-container">
        <h2 className="dhs-section-title">OUR SERVICES</h2>
        <p className="dhs-services-subtitle">No Job Too Small</p>
        <div className="dhs-section-underline" />

        <div className="dhs-services-grid">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="dhs-service-item">
                <div className="dhs-service-icon">
                  <Icon size={44} strokeWidth={1.8} />
                </div>
                <p className="dhs-service-title">
                  {s.title.split("\n").map((line, j) => (
                    <span key={j}>{line}<br /></span>
                  ))}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
